import * as apiTo from '@/modular-api'

const initialState = () => ({
  exportLoading: false,
  loading: false,
  tableState: {
    filter: null,
    columns: null
  }
})

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    setExportLoading: (state, newVal) => (state.exportLoading = newVal),
    setLoading: (state, newVal) => (state.loading = newVal),
    setTableStateFilter: (state, payload) => (state.tableState.filter = payload),
    setTableStateColumns: (state, payload) => (state.tableState.columns = payload),
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetTableState({ commit }, listView) {
      return apiTo.GET_LIST_VIEW_TABLE_STATE(listView).then(({ data }) => {
        commit('setTableStateFilter', data.result.filter)
        commit('setTableStateColumns', data.result.columns)

        return data
      })
    },

    saveTableState({ state }, listView) {
      return apiTo.MODIFY_LIST_VIEW_TABLE_STATE(listView, {
        filter: state.tableState.filter,
        columns: state.tableState.columns
      })
    }
  }
}
